import React from 'react';

interface PillProps {
  href?: string;
  icon?: string;
  onClick?: () => void;
  text: string;
}

export default function Pill({ text, icon, href, onClick }: PillProps) {
  const pillJSX = (
    <>
      <span className="pill-text">{text}</span>
      {icon && <img src={icon} className="link-icon" />}
    </>
  );

  return href || onClick ? (
    <a href={href} onClick={onClick} className="Pill is-link">
      {pillJSX}
    </a>
  ) : (
    <span className="Pill">{pillJSX}</span>
  );
}
